function excelTimeToString(excelTime) {
    if (!excelTime) {
      return null;
    }
    // Convert fraction of day to total seconds
    const totalSeconds = Math.round(excelTime * 24 * 60 * 60);

    // Extract hours and minutes
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);

    // Format as HH:MM
    const hh = hours.toString().padStart(2, '0');
    const mm = minutes.toString().padStart(2, '0');

    return `${hh}:${mm}`;
  }
  function excelDateToString(excelSerial) {
    if (!excelSerial) {
      return null;
    }
    // Excel epoch starts at 1899-12-30
    const excelEpoch = new Date(Date.UTC(1899, 11, 30));

    // Only integer part counts for the date
    const days = Math.floor(excelSerial);

    const date = new Date(excelEpoch.getTime() + days * 24 * 60 * 60 * 1000);

    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
    const dd = String(date.getUTCDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
}





module.exports = { 
    excelTimeToString, 
    excelDateToString,
}